/**
 * Dev-only logging wrapper.
 * In production builds (NODE_ENV === 'production') these become no-ops so we don't
 * leak internal state into user consoles or degrade performance.
 */
const isDev = process.env.NODE_ENV !== "production";

export const devLog = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};
